import { useState, useCallback } from 'react';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { ref, getBlob } from 'firebase/storage';

const useZipDownload = (storageInstance) => { // Accept storageInstance as a parameter
  const [isZipping, setIsZipping] = useState(false);
  const [zipProgress, setZipProgress] = useState(0); // 0-100
  const [error, setError] = useState(null);

  const downloadZip = useCallback(async (filesToZip, zipFileName = 'download.zip') => {
    setIsZipping(true);
    setZipProgress(0);
    setError(null);

    try {
      const zip = new JSZip();
      let filesProcessed = 0;
      const totalFiles = filesToZip.length;

      for (const fileItem of filesToZip) {
        if (!fileItem.fullPath || !fileItem.name) {
          console.warn('Skipping invalid file item:', fileItem);
          filesProcessed++;
          continue;
        }

        try {
          const fileRef = ref(storageInstance, fileItem.fullPath);
          const blob = await getBlob(fileRef);
          zip.file(fileItem.name, blob);

          filesProcessed++;
          setZipProgress(Math.floor((filesProcessed / totalFiles) * 50));
        } catch (fetchError) {
          console.error(`Error processing file ${fileItem.name}:`, fetchError);
          filesProcessed++;
        }
      }

      setZipProgress(50);

      const content = await zip.generateAsync({ type: "blob" }, (metadata) => {
        const percent = 50 + Math.floor(metadata.percent / 2);
        if (percent > zipProgress) {
            setZipProgress(percent);
        }
      });

      saveAs(content, zipFileName);
      setZipProgress(100);

    } catch (err) {
      console.error("Error creating or downloading zip:", err);
      setError(err);
      setZipProgress(0);
    } finally {
      setIsZipping(false);
    }
  }, [zipProgress, storageInstance]); // Add storageInstance to dependencies

  return { downloadZip, isZipping, zipProgress, error };
};

export default useZipDownload;
